import { useEffect } from "react";

/**
 * Lightweight SEO helper: sets document title, meta description and og tags.
 * Avoids extra dependency; restores defaults on unmount.
 */
export default function useSEO({ title, description, image }) {
    useEffect(() => {
        const prevTitle = document.title;
        if (title) document.title = title;

        const setMeta = (name, content, attr = "name") => {
            if (!content) return null;
            let el = document.querySelector(`meta[${attr}="${name}"]`);
            const created = !el;
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, name);
                document.head.appendChild(el);
            }
            const prev = el.getAttribute("content");
            el.setAttribute("content", content);
            return { el, prev, created };
        };

        const restorers = [
            setMeta("description", description),
            setMeta("og:title", title, "property"),
            setMeta("og:description", description, "property"),
            setMeta("og:image", image, "property"),
            setMeta("twitter:card", "summary_large_image"),
            setMeta("twitter:title", title),
            setMeta("twitter:description", description),
        ].filter(Boolean);

        return () => {
            document.title = prevTitle;
            restorers.forEach((r) => {
                if (!r) return;
                if (r.created) r.el.remove();
                else if (r.prev !== null) r.el.setAttribute("content", r.prev);
            });
        };
    }, [title, description, image]);
}
